import { render, staticRenderFns } from "./EsgBaseCardHeader.vue?vue&type=template&id=0cf85a8e&scoped=true"
import script from "./EsgBaseCardHeader.vue?vue&type=script&lang=js"
export * from "./EsgBaseCardHeader.vue?vue&type=script&lang=js"
import style0 from "./EsgBaseCardHeader.vue?vue&type=style&index=0&id=0cf85a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf85a8e",
  null
  
)

export default component.exports